import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
	actions: {
		async fetchFiles({commit, state}, {groupId, id}) {
			if (state.filesByGroup[groupId]) {
				state.latestFile = state.filesByGroup[groupId][0];
				return state.filesByGroup[groupId];
			}

			let response = await axios.get('/api/files.php', {
				params: {
					group_id: groupId,
					id,
				}
			});

			if (groupId) {
				commit('SET_FILES', {groupId, files: response.data});
			} else {
				return response.data[0];
			}
		},
		async fetchGroups({commit, state}) {
			if (state.groups.length) {
				return;
			}

			let response = await axios.get('/api/groups.php');
			commit('SET_GROUPS', response.data);
		},
	},
	mutations: {
		SET_FILES(state, {groupId, files}) {
			Vue.set(state.filesByGroup, groupId, files);
			state.latestFile = files[0];
		},
		SET_GROUPS(state, groups) {
			state.groups = groups;
		},
	},
	state: {
		filesByGroup: {},
		groups: [],
		latestFile: {},
		unityVersion: "6.0.49f1",
		unityVersionShort: "6.0.x",
		gameVersion: "v1.10.0",
	},
});
